import { atom } from "jotai";
import { nodesAtom } from "../nodes";
import { edgesAtom } from "../edges";
import { isTourableNode } from "../utils";

/**
 * Fine-grained selector that returns true if there are connected tourable nodes.
 * A tour is only meaningful when nodes form a connected workflow, not just isolated nodes.
 * This prevents components from re-rendering on every node/edge change by only updating
 * when the connected tourable status actually changes.
 */
export const hasTourableNodesAtom = atom((get) => {
  const nodes = get(nodesAtom);
  const edges = get(edgesAtom);

  const tourableNodes = nodes.filter(isTourableNode);
  const tourableNodeIds = new Set(tourableNodes.map((n) => n.id));

  // Need at least 2 tourable nodes for a meaningful tour
  if (tourableNodeIds.size < 2) {
    return false;
  }

  // Check if any edges connect tourable nodes to each other
  return edges.some(
    (edge) =>
      tourableNodeIds.has(edge.source) && tourableNodeIds.has(edge.target),
  );
});

hasTourableNodesAtom.debugLabel = "hasTourableNodesAtom";
